import React, { useEffect, useState } from 'react';
import TrainingService from '../../Service/TrainingService';

const TrainingObj = ({ training }) => {
    const [editMode, setEditMode] = useState(false);
    const [textAreaValue, setTextAreaValue] = useState('');
    const token = sessionStorage.getItem('token');

    // Convert HTML to plain text for editing
    useEffect(() => {
        if (training.goals) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = training.goals; // Training goals initially in HTML
            setTextAreaValue(tempDiv.innerText); // Convert HTML to plain text for editing
        }
    }, [training.goals]);

    const handleEditClick = () => {
        setEditMode(true);
    };

    const handleInputChange = (event) => {
        setTextAreaValue(event.target.value);
    };

    const handleSaveClick = async () => {
        // Save the modified text back to training object
        training.goals = textAreaValue;  // Modified text is in plain text

        try {
            let response;
            if (training.modif) {
                response = await TrainingService.putModifTraining(training);
            } else {
                response = await TrainingService.postModifTraining(training);
            }
            window.location.reload();
            console.log(response);
        } catch (error) {
            console.log("Error: " + error);
        }
        setEditMode(false);
    };

    return (
        <div className="section-content">
            {editMode ? (
                // Edit mode: display textarea for modifying the content
                <textarea
                    value={textAreaValue}
                    onChange={handleInputChange}
                    rows={10}
                    style={{ width: '100%' }}
                />
            ) : (
                // Display mode: render the content with HTML safely
                <div>
                    <p className="objectives-description">Cette formation suit les objectifs suivants :</p>
                    <div className="objective-card">
                        <img
                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/c7572cf9cd42f0f79a4b2c1b5888068cd144cd81e5018549241029c3c1d193b2?apiKey=59156c16963f46e28d2e0d857e2bfa45&"
                            alt="Objectif Icon"
                            className="objective-icon"
                        />
                        <p className="objective-text">
                            <div style={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{ __html: training.goals }} />
                        </p>
                    </div>
                </div>
            )}
            {editMode ? (
                <button
                    className="inscription-button modif_button"
                    onClick={handleSaveClick}
                    style={{ right: 0 }}
                >
                    Enregistrer
                </button>
            ) : (
                token === '' && (
                    <button
                        className="inscription-button modif_button"
                        onClick={handleEditClick}
                        style={{ marginLeft: '10px' }}
                    >
                        Modifier
                    </button>
                )
            )}
        </div>
    );
};

export default TrainingObj;